<template>
  <div class="container auth-header mb-1 px-lg-0 px-1" style="max-width: 1185px">
    <div class="d-flex align-items-center justify-content-between w-100 pt-2">
      <ul
        class="d-lg-flex d-none align-items-center justify-content-between mb-0 pl-0"
      >
        <div
          v-for="(item, index) in menu"
          :key="index"
          class="mr-3 position-relative py-1 my-1"
        >
          <div class="d-flex align-items-center py-1 links">
            <div
              class="puls animate-pulse mr-50"
              v-if="item.route == '/competitions'"
            ></div>
            <b-link
              class="text-white h5 mb-0"
              :href="`https://fxlegends.com${item.route}`"
              >{{ item.name }}</b-link
            >
          </div>

          <div
            class="child position-absolute p-2 rounded shadow-lg top-100 left-0"
            style="z-index: 1000; background: #1b1b24"
            v-if="item.children && item.children.length"
          >
            <div
              v-for="(childItem, childIndex) in item.children"
              :key="childIndex"
              :class="[item.children.length - 1 !== childIndex && 'pb-1']"
            >
              <b-link
                class="text-white h5 nowrap-white-space"
                :href="`https://fxlegends.com${childItem.route}`"
                >{{ childItem.name }}</b-link
              >
            </div>
          </div>
        </div>
      </ul>
      <div class="d-lg-none d-flex">
        <feather-icon
          icon="MenuIcon"
          class="text-white cursor-pointer"
          style="width: 25px; height: 25px"
          @click="showMenu = true"
        />
      </div>
      <div>
        <b-button
          class="gradient-btn py-1 d-flex align-items-center"
          style="border-radius: 10px !important"
        >
          <feather-icon
            icon="UserIcon"
            class="mr-50"
            style="width: 18px; height: 18px"
          />
          <b-link class="text-white" to="/auth/user/register"> Sign Up</b-link>
          <span class="mx-25">/</span>
          <b-link class="text-white" to="/auth/user/login"> Sign in</b-link>
        </b-button>
      </div>
    </div>
    <div
      class=" w-100 h-100 top-0 left-0 bg-dark"
      style="z-index: 100; opacity: 0.5;position: fixed;"
      v-if="showMenu"
      @click="showMenu = false"
    ></div>
    <transition name="fade" mode="out-in">
      <div
        class="left-0 top-0 h-100 w-full"
        style="z-index: 1000; position: fixed;overflow-y:auto;"
        v-if="showMenu"
      >
        <div class="h-100"  style="background: #1b1b24">
          <ul class="d-lg-none d-flex flex-column mb-0 py-2 pl-3 pr-4">
            <div v-for="(item, index) in menu" :key="index" class="py-2">
              <div class="d-flex align-items-center">
                <div
                  class="puls mr-50"
                  v-if="item.route == '/competitions'"
                ></div>
                <b-link
                  class="text-white h5 mb-0"
                  :href="`https://fxlegends.com${item.route}`"
                  >{{ item.name }}</b-link
                >
                <feather-icon
                  v-if="item.children && item.children.length"
                  icon="ChevronDownIcon"
                  class="ml-auto"
                  style="width: 18px; height: 18px"
                  @click="showChild = !showChild"
                />
              </div>
              <transition name="fade" mode="out-in">
                <div
                  class="child pt-1 mt-50 px-50 rounded shadow-lg top-100 left-0"
                  v-if="showChild && item.children && item.children.length"
                >
                  <div
                    v-for="(childItem, childIndex) in item.children"
                    :key="childIndex"
                    :class="[item.children.length - 1 !== childIndex && 'pb-75']"
                  >
                    <b-link
                      class="text-white h5 nowrap-white-space"
                      :href="`https://fxlegends.com${childItem.route}`"
                      >{{ childItem.name }}</b-link
                    >
                  </div>
                </div>
              </transition>
            </div>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { BLink, BButton } from "bootstrap-vue";
export default {
  components: {
    BLink,
    BButton,
  },
  data() {
    return {
      showMenu: false,
      showChild: false,
      menu: [
        {
          name: "Live Competitions",
          route: "/competitions",
        },
        {
          name: "Leaderboard",
          route: "/",
        },
        {
          name: "Affiliation",
          route: "/affiliation",
        },
        {
          name: "Policies",
          route: "/privacy-policy",
          children: [
            {
              name: "Terms and Conditions",
              route: "/terms-and-conditions",
            },
            {
              name: "Privacy Policy",
              route: "/privacy-policy",
            },
            {
              name: "Refund Policy",
              route: "/refund-and-return-policy",
            },
            {
              name: "Legal Notices",
              route: "/legal-notices",
            },
          ],
        },
        {
          name: "Contact Us",
          route: "/contact-us",
        },
        {
          name: "Partner Area",
          route: "/partner-register",
        },
      ],
    };
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
